import React, { useState, useRef, useEffect } from "react";
import "./FilterDropdown.css";

const FilterDropdown = ({ value, options, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleToggle = () => setIsOpen(!isOpen);

    const handleSelect = (name) => {
        onChange(name);
        setIsOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const selectedOption = options.find((opt) => opt.name === value) || options[0];

    return (
        <div className="filter-dropdown" ref={dropdownRef}>
            <button type="button" className="filter-dropdown__trigger" onClick={handleToggle}>
                {selectedOption.name} <i className={`bx bx-chevron-${isOpen ? 'up' : 'down'} filter-dropdown__icon`}></i>
            </button>
            {isOpen && (
                <ul className="filter-dropdown__menu">
                    {options.map((opt, idx) => (
                        <li
                            key={idx}
                            className={`filter-dropdown__item ${opt.name === value ? "active" : ""}`}
                            onClick={() => handleSelect(opt.name)}
                        >
                            {opt.name}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default FilterDropdown;
